import {
  TURBINES_PATHS,
  TURBINES_DETAILS_PATHS,
  TURBINES_HISTORY_PATHS
} from '../constants/turbines';

const deepGet = (obj, path) => {
  if (!obj || typeof obj !== 'object') return undefined;
  if (!path || typeof path !== 'string') return undefined;

  return path.split('.').reduce((o, key) => {
    if (o === undefined || o === null) return undefined;
    const numKey = Number(key);
    if (!isNaN(numKey) && Array.isArray(o)) {
      return o[numKey];
    }
    return typeof o === 'object' ? o[key] : undefined;
  }, obj);
};

export function getAlarmsPath(turbineData) {
  return deepGet(turbineData, TURBINES_DETAILS_PATHS.alarms);
}

export function getShutdownsPath(turbineData) {
  return deepGet(turbineData, TURBINES_DETAILS_PATHS.shutdowns);
}

export function getTurbineDataPath(turbineData) {
  return deepGet(turbineData, TURBINES_PATHS.turbineData);
}

export function getSentAtPath(turbineData) {
  return deepGet(turbineData, TURBINES_PATHS.sentAt);
}

export function getSummaryPath(turbineData) {
  return deepGet(turbineData, TURBINES_DETAILS_PATHS.summary);
}

export function getControlPath(turbineData) {
  return deepGet(turbineData, TURBINES_DETAILS_PATHS.control);
}

export function getGeneratorSummaryPath(turbineData) {
  return deepGet(turbineData, TURBINES_DETAILS_PATHS.generatorSummary);
}

export function getGeneratorTemperaturesPath(turbineData) {
  return deepGet(turbineData, TURBINES_DETAILS_PATHS.generatorTemperatures);
}

export function getTurbineInstrumentsPath(turbineData) {
  return deepGet(turbineData, TURBINES_DETAILS_PATHS.turbineInstruments);
}

export function getTurbineFuelSystemPath(turbineData) {
  return deepGet(turbineData, TURBINES_DETAILS_PATHS.turbineFuelSystem);
}

export function getTurbineStarterPath(turbineData) {
  return deepGet(turbineData, TURBINES_DETAILS_PATHS.turbineStarter);
}

export function getVibrationBearingsPath(turbineData) {
  return deepGet(turbineData, TURBINES_DETAILS_PATHS.vibrationBearings);
}

export function getLubePath(turbineData) {
  return deepGet(turbineData, TURBINES_DETAILS_PATHS.lube);
}

export function getEnclosurePath(turbineData) {
  return deepGet(turbineData, TURBINES_DETAILS_PATHS.enclosure);
}

export function getHistoryUnitPath(historyData) {
  return deepGet(historyData, TURBINES_HISTORY_PATHS.unit);
}
